import { fromJS } from 'immutable';
import { visibleColumns } from '../../event/related-runup/runupReduxConstants';
import { resolveErrors } from '../../../../components/grid/resultGridUtils';


export const RUNUP_DATA_DELETE_RUNUP_REQUEST = 'RUNUP_DATA_DELETE_RUNUP_REQUEST';
export const RUNUP_DATA_DELETE_RUNUP_SUCCESS = 'RUNUP_DATA_DELETE_RUNUP_SUCCESS';
export const RUNUP_DATA_DELETE_RUNUP_FAILURE = 'RUNUP_DATA_DELETE_RUNUP_FAILURE';

export const RUNUP_DATA_CLEAR = 'RUNUP_DATA_CLEAR';

export const RUNUP_DATA_REGION_REQUEST = 'RUNUP_DATA_REGION_REQUEST';
export const RUNUP_DATA_REGION_SUCCESS = 'RUNUP_DATA_REGION_SUCCESS';
export const RUNUP_DATA_REGION_FAILURE = 'RUNUP_DATA_REGION_FAILURE';

export const RUNUP_DATA_RUNUP_REGION_REQUEST = 'RUNUP_DATA_RUNUP_REGION_REQUEST';
export const RUNUP_DATA_RUNUP_REGION_SUCCESS = 'RUNUP_DATA_RUNUP_REGION_SUCCESS';
export const RUNUP_DATA_RUNUP_REGION_FAILURE = 'RUNUP_DATA_RUNUP_REGION_FAILURE';

export const RUNUP_DATA_MEASURE_TYPE_REQUEST = 'RUNUP_DATA_MEASURE_TYPE_REQUEST';
export const RUNUP_DATA_MEASURE_TYPE_SUCCESS = 'RUNUP_DATA_MEASURE_TYPE_SUCCESS';
export const RUNUP_DATA_MEASURE_TYPE_FAILURE = 'RUNUP_DATA_MEASURE_TYPE_FAILURE';

export const RUNUP_DATA_VALIDITY_REQUEST = 'RUNUP_DATA_VALIDITY_REQUEST';
export const RUNUP_DATA_VALIDITY_SUCCESS = 'RUNUP_DATA_VALIDITY_SUCCESS';
export const RUNUP_DATA_VALIDITY_FAILURE = 'RUNUP_DATA_VALIDITY_FAILURE';

export const RUNUP_DATA_CAUSE_REQUEST = 'RUNUP_DATA_CAUSE_REQUEST';
export const RUNUP_DATA_CAUSE_SUCCESS = 'RUNUP_DATA_CAUSE_SUCCESS';
export const RUNUP_DATA_CAUSE_FAILURE = 'RUNUP_DATA_CAUSE_FAILURE';

export const RUNUP_DATA_TOGGLE_COLUMN = 'RUNUP_DATA_TOGGLE_COLUMN';

export const RUNUP_DATA_SAVE_OPEN_CONFIRMATION = 'RUNUP_DATA_SAVE_OPEN_CONFIRMATION';
export const RUNUP_DATA_SAVE_CANCEL_CONFIRMATION = 'RUNUP_DATA_SAVE_CANCEL_CONFIRMATION';
export const RUNUP_DATA_CANCEL_EDIT = 'RUNUP_DATA_CANCEL_EDIT';
export const RUNUP_DATA_EDIT = 'RUNUP_DATA_EDIT';
export const RUNUP_DATA_BULK_EDIT_REQUEST = 'RUNUP_DATA_BULK_EDIT_REQUEST';
export const RUNUP_DATA_BULK_EDIT_SUCCESS = 'RUNUP_DATA_BULK_EDIT_SUCCESS';
export const RUNUP_DATA_BULK_EDIT_FAILURE = 'RUNUP_DATA_BULK_EDIT_FAILURE';

const initialState = fromJS({
  deleting: false,
  fetchedRegions: false,
  regions: [],
  fetchedRunupRegions: false,
  runupRegions: [],
  fetchedRunupMeasurementTypes: false,
  runupMeasurementTypes: [],
  fetchedValidities: false,
  validities: [],
  fetchedCauses: false,
  causes: [],
  visibleColumns,

  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const runupDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case RUNUP_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case RUNUP_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));

    case RUNUP_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case RUNUP_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));

    case RUNUP_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case RUNUP_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case RUNUP_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));

    case RUNUP_DATA_CLEAR:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
      }));
    case RUNUP_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case RUNUP_DATA_DELETE_RUNUP_REQUEST:
      return state.set('deleting', true);
    case RUNUP_DATA_DELETE_RUNUP_SUCCESS:
    case RUNUP_DATA_DELETE_RUNUP_FAILURE:
      return state.set('deleting', false);


    case RUNUP_DATA_VALIDITY_REQUEST:
      return state.merge(fromJS({
        fetchedValidities: false,
      }));
    case RUNUP_DATA_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        fetchedValidities: true,
        validities: action.response.items,
      }));
    case RUNUP_DATA_VALIDITY_FAILURE:
      return state.merge(fromJS({
        fetchedValidities: true,
      }));

    case RUNUP_DATA_CAUSE_REQUEST:
      return state.merge(fromJS({
        fetchedCauses: false,
      }));
    case RUNUP_DATA_CAUSE_SUCCESS:
      return state.merge(fromJS({
        fetchedCauses: true,
        causes: action.response.items,
      }));
    case RUNUP_DATA_CAUSE_FAILURE:
      return state.merge(fromJS({
        fetchedCauses: true,
      }));

    case RUNUP_DATA_MEASURE_TYPE_REQUEST:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: false,
      }));
    case RUNUP_DATA_MEASURE_TYPE_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
        runupMeasurementTypes: action.response.items,
      }));
    case RUNUP_DATA_MEASURE_TYPE_FAILURE:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
      }));

    case RUNUP_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case RUNUP_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case RUNUP_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case RUNUP_DATA_RUNUP_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRunupRegions: false,
      }));
    case RUNUP_DATA_RUNUP_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
        runupRegions: action.response.items,
      }));
    case RUNUP_DATA_RUNUP_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
      }));
    default:
      return state;
  }
};
